var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 515.556 515.556",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m486.245 337.232c-44.199-27.886-94.804-43.186-147.101-46.048 12.091 5.66 24.059 11.637 35.408 18.798 27.345 17.228 44.337 48.428 44.337 81.405v91.947h96.667v-91.947c0-21.995-11.233-42.748-29.311-54.155z",
    fill: "#8298ab",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m357.356 337.232c-97.957-61.801-230.103-61.801-328.029 0-18.093 11.391-29.327 32.144-29.327 54.155v91.947h386.667v-91.947c0-22.011-11.234-42.764-29.311-54.155z",
    fill: "#8298ab",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m289.815 252.441c10.416 3.153 21.165 5.338 32.409 5.338 62.179 0 112.778-50.599 112.778-112.778s-50.599-112.779-112.778-112.779c-11.244 0-21.993 2.185-32.409 5.338 29.553 26.562 48.52 64.665 48.52 107.44s-18.966 80.878-48.52 107.441z",
    fill: "#8298ab",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m273.081 65.254c44.043 44.043 44.043 115.449 0 159.492s-115.449 44.043-159.492 0-44.043-115.449 0-159.492 115.449-44.042 159.492 0",
    fill: "#8298ab",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunities);
export default __webpack_public_path__ + "static/media/communities.6d3106ce.svg";
export { ForwardRef as ReactComponent };